<div>
    <app-button
            (click)="navigateToLogin()"
            [label]="'forgot_password.success_button_label' | translate"
            [size]="isMobile ? ButtonSize.LARGE : ButtonSize.LARGER"
            [state]="ButtonState.REGULAR"
            [type]="ButtonType.PRIMARY"
    ></app-button>
</div>
